import type { SVGProps } from 'react'
const SvgSyTechSolidManagedService = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path fill="#e9e9e9" d="M11 2v20l10-8z" />
		<path d="m11 2-.98 1.17 8.85 10.61-8.8 7.05.94 1.17L21 13.99z" />
		<path
			fill="#e9e9e9"
			d="M11 2 7 6.75a3.1 3.1 0 0 1 1.11 1L11 4.34zM8.35 18a2.93 2.93 0 0 1-.92 1.19L11 22v-1.92z"
		/>
		<path
			fillOpacity={0.24}
			d="M6 10a1 1 0 1 1 1-1 1 1 0 0 1-1 1m0-4a3 3 0 1 0 3 3 3 3 0 0 0-3-3m0 12a1 1 0 1 1 1-1 1 1 0 0 1-1 1m0-4a3 3 0 1 0 3 3 3 3 0 0 0-3-3"
		/>
	</svg>
)
export default SvgSyTechSolidManagedService
